import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["queryReference"];
import _rootUiModificationsQuery from "./__generated__/rootUiModificationsQuery.graphql";
import React from 'react';
import { di } from 'react-magnetic-di';
import { graphql, usePreloadedQuery } from 'react-relay';
import Placeholder from '@atlassian/react-ufo/placeholder';
import { UiModificationsRootFragment } from './fragment';
import { RelayErrorBoundary } from './relay-error-boundary';
/**
 * UI modifications root component with usePreloadedQuery.
 *
 * Use it to attach to router or event if there is no possibility to use UiModificationsRootFragment.
 * In most cases we should use UiModificationsRootFragment.
 */
export var UiModificationsRoot = function UiModificationsRoot(props) {
  var queryReference = props.queryReference;
  if (!queryReference) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Placeholder, {
    name: "ui-modifications-root-query",
    fallback: null
  }, /*#__PURE__*/React.createElement(RelayErrorBoundary, null, /*#__PURE__*/React.createElement(RootQuery, _extends({}, props, {
    queryReference: queryReference
  }))));
};
var RootQuery = function RootQuery(props) {
  var queryReference = props.queryReference,
    restProps = _objectWithoutProperties(props, _excluded);
  var data = usePreloadedQuery(_rootUiModificationsQuery, queryReference);
  return /*#__PURE__*/React.createElement(UiModificationsRootFragment, _extends({}, restProps, {
    fragmentRef: data
  }));
};